import { gql } from "@apollo/client";
import { ArtifactSingular, Quote, SoundExplorer, Spotlight, ArtifactPaper, InducteeEssay } from "@components";
import Quiz from "@/components/DigitalExhibit/DigitalExhibitQuiz/DigitalExhibitQuiz";

export const TheirImpactFragment = gql`
  ${SoundExplorer.fragments.entry}
  ${ArtifactSingular.fragments.inducteeEntry}
  ${ArtifactPaper.fragments.entry}
  ${Spotlight.fragments.inducteeEntry}
  ${Quote.fragments.inducteeEntry}
  ${InducteeEssay.fragments.entry}
  ${Quiz.fragments.inducteeEntry}
  fragment TheirImpact on Inductee {
    inducteeData {
      includeImpactSection
      impactHero {
        headline
        type
        quote {
          quote
          role
          name
          imageAttribution
          image {
            ...ACFMedia
          }
        }
        video {
          videoTitle
          videoType
          youtubeVideoId
          videoUrl
          previewVideoUrl
          videoThumbnail {
            ...ACFMedia
          }
          youtubeThumbnail {
            ...ACFMedia
          }
        }
      }
      impactFlexibleContent {
        ...SoundExplorer
        ...InducteeArtifactSingular
        ...InducteeArtifactPaper
        ...InducteeSpotlight
        ...InducteeQuote
        ...InducteeEssay
        ...ImpactQuiz
      }
    }
  }
`;
